       
              <div class="cardBox mb-20">

                <ion-row class="ion-align-items-center ion-justify-content-start ml-20 pt-20">

                  <!-- Year Select -->
                  <ion-col size="12" size-sm="3">
                    <mat-form-field class="custom-mat-field mat-height40 mat-input-style w-100">
                      <mat-select placeholder="Select Year" [(ngModel)]="selectedYearForCompetency"
                                  (selectionChange)="getYearSetupForReimbursement(selectedYearForCompetency)">
                        <mat-option *ngFor="let item of pmsYears" [value]="item.year">
                          {{ sharedService.transformYearToFyFormat(item.year) }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>
                
              
                
                  <!--Program select -->
                  <ion-col size="12" size-sm="3">
                    <mat-form-field class="mat-height40 mat-input-style" >
                      <mat-select placeholder="Select program">
                        <mat-option *ngFor="let program of programList" [value]="program">
                          {{ program }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>            
                
                </ion-row>
                
               <hr style="border: none; height: 1px; background-color: #cccccc8f;" />

                <ion-row class="ion-align-items-center ion-justify-content-between ml-10">
                  <ion-col size="12" size-lg="9">
                    <ion-row class="ion-align-items-center">
                      <!-- Search -->
                      <ion-col size="12" size-sm="4" >
                        <mat-form-field class="mat-height40 mat-input-style w-100">
                          <mat-icon matPrefix>search</mat-icon>
                          <input matInput type="search" placeholder="Search" [(ngModel)]="searchTerm" (input)="filterEmployees()">
                        </mat-form-field>
                      </ion-col>
                    </ion-row>
                  </ion-col>
                
                  <ion-col size="12" size-lg="3" >
                    <div class="d-flex justify-content-end align-items-center" style="gap: 10px;">    
                      <label>
                        <ion-label class="fs-14 font_regular pr-10 black_color ml-10">Show</ion-label>
                        <mat-form-field class="w70px mat-height40 mat-input-style">
                          <mat-select placeholder="Select" (selectionChange)="DislaySelectedRecord($event)">
                            <mat-option [value]="2">2</mat-option>
                            <mat-option [value]="25">25</mat-option>
                            <mat-option [value]="50">50</mat-option>
                            <mat-option [value]="75">75</mat-option>
                            <mat-option [value]="100">100</mat-option>
                          </mat-select>
                        </mat-form-field>
                        <ion-label class="fs-14 font_regular pl-10 black_color">entries</ion-label>
                      </label>
                      <!-- Download Icon -->
                      <span class="icon-download fs-20 material-icons" style="cursor: pointer;" (click)="downloadEmployeeList()">download</span>
                    </div>
                  </ion-col>
                
                </ion-row>
                

                <div class="p-10">
                  <ion-row>
                    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                  
                    <div class="table-container">
                      <table class="custom-table rounded-header">
                        <thead>
                          <tr>
                            <ng-container *ngFor="let item of tableHeaders">
                              <th *ngIf="item.label !== 'Action'" class="fs-14 font_bold cl-black">
                                <div class="verticle-center justify-content-space-between icon-style">
                                  {{ item?.label }}
                                </div>
                              </th>
                            </ng-container>
                          </tr>
                        </thead>
                          <tbody class="bg-white">
                            <tr *ngFor="let program of trainingPrograms">
                              <td>{{program.title}}</td>
                              <td>{{ program.nominated }}</td>
                              <td>{{ program.approved }}</td>
                              <td>{{ program.rejected }}</td>
                              <td>{{ program.present }}</td>
                              <td>{{ program.absent }}</td>
                              <td >{{program.attendance}}</td>
                            </tr>
                          </tbody>
                      </table>
                    </div>
                    </ion-col>
                  </ion-row>
                </div>
              </div>
            